<template>
  <div class="home">
    <quote-grid-for-admin></quote-grid-for-admin>
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from '@/components/Container/Hero.vue'
import QuoteGridForAdmin from '@/components/Container/QuoteGridForAdmin'

export default {
  name: 'home',
  components: {
    Hero, 
    QuoteGridForAdmin
  }
}
</script>
